import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '@/store/store';

interface SensorDataState {
  graphLegend: {
    current?: Array<any>; // TODO: Define types
    pinned?: Array<any>; // TODO: Define types
  };
}

const initialState: SensorDataState = {
  graphLegend: {
    current: undefined,
    pinned: undefined,
  },
};

export const sensorDataSlice = createSlice({
  initialState,
  name: 'sensorData',
  reducers: {
    setGraphLegend: (state, action) => {
      state.graphLegend = { ...action.payload };
    },
    resetGraphLegend: () => initialState,
  },
});

export const { setGraphLegend, resetGraphLegend } = sensorDataSlice.actions;

export const sensorDataSelectors = {
  graphLegend: (state: RootState) => state.sensorData.graphLegend,
};
